export const cooperationInfo: any = {
  '1': [
    {
      name: '保证金',
      desc: '保证金，是指商家向平台缴纳，用以保证平台规则和平台协议的履行以及对商品和服务质量进行担保的款项'
    },
    {
      name: '营业执照',
      desc: '国内企业：需提供三证合一的营业执照原件扫描件或加盖公司公章的复印件；跨境企业：提供企业生产经营相关证件。露出证件四角，请勿遮挡或模糊，保持信息清晰可见'
    },
    {
      name: '法定代表人信息',
      desc: '中国大陆居民请上传居民身份证；港澳台居民请上传港澳居民往来内地通行证、台湾居民往来大陆通行证或者港澳台居民通行及身份证；海外人士请上传护照。证件图片内容文字需可清晰辨认'
    }
  ],
  '2': [
    {
      name: '保证金',
      desc: '保证金，是指商家向平台缴纳，用以保证平台规则和平台协议的履行以及对商品和服务质量进行担保的款项'
    },
    {
      name: '营业执照',
      desc: '国内企业：需提供三证合一的营业执照原件扫描件或加盖公司公章的复印件；跨境企业：提供企业生产经营相关证件。露出证件四角，请勿遮挡或模糊，保持信息清晰可见'
    },
    {
      name: '法定代表人信息',
      desc: '中国大陆居民请上传居民身份证；港澳台居民请上传港澳居民往来内地通行证、台湾居民往来大陆通行证或者港澳台居民通行及身份证；海外人士请上传护照。证件图片内容文字需可清晰辨认'
    }
  ],
  '3': [
    {
      name: '保证金',
      desc: '保证金，是指商家向平台缴纳，用以保证平台规则和平台协议的履行以及对商品和服务质量进行担保的款项'
    },
    {
      name: '营业执照',
      desc: '国内企业：需提供三证合一的营业执照原件扫描件或加盖公司公章的复印件；跨境企业：提供企业生产经营相关证件。露出证件四角，请勿遮挡或模糊，保持信息清晰可见'
    }
  ],
}

export const natureInfo: any = {
  '1': [
    {
      name: '商标注册证或商标注册申请受理通知书',
      desc: '提供有效期内的商标注册证，露出证件四角，请勿遮挡或模糊，保持信息清晰可见；若办理过变更、转让、续展，请补充上传商标总局颁发的变更、转让、续展证明或受理通知书'
    },
    {
      name: '商标授权文件',
      desc: '如商标注册人非入驻企业或实际经营方，请提供商标使用授权书或关联关系证明；以商标注册人为源头的完整授权链路；若商标权利人为自然人，需提供商标权利人亲笔签名的身份证正反两面复印件或亲笔签名+商标权利人手印的授权'
    },
  ],
  '2': [
    {
      name: '商标注册证或商标注册申请受理通知书',
      desc: '提供有效期内的商标注册证，露出证件四角，请勿遮挡或模糊，保持信息清晰可见；若办理过变更、转让、续展，请补充上传商标总局颁发的变更、转让、续展证明或受理通知书'
    },
    {
      name: '商标授权文件',
      desc: '如商标注册人非入驻企业或实际经营方，请提供商标使用授权书或关联关系证明；以商标注册人为源头的完整授权链路；若商标权利人为自然人，需提供商标权利人亲笔签名的身份证正反两面复印件或亲笔签名+商标权利人手印的授权'
    },
  ],
  '3': [
    {
      name: '商标注册证或商标注册申请受理通知书',
      desc: '提供有效期内的商标注册证，露出证件四角，请勿遮挡或模糊，保持信息清晰可见；若办理过变更、转让、续展，请补充上传商标总局颁发的变更、转让、续展证明或受理通知书'
    },
    {
      name: '商标授权文件',
      desc: '如商标注册人非入驻企业或实际经营方，请提供商标使用授权书或关联关系证明；以商标注册人为源头的完整授权链路；若商标权利人为自然人，需提供商标权利人亲笔签名的身份证正反两面复印件或亲笔签名+商标权利人手印的授权'
    },
    {
      name: '采购凭证',
      desc: '无法提供《经销或商标使用授权书》的，需提供从品牌方到供应商的完整链路的采购凭证'
    }
  ],
  '4': [
    {
      name: '商标注册证或商标注册申请受理通知书',
      desc: '提供有效期内的商标注册证，露出证件四角，请勿遮挡或模糊，保持信息清晰可见；若办理过变更、转让、续展，请补充上传商标总局颁发的变更、转让、续展证明或受理通知书'
    },
    {
      name: '商标授权文件',
      desc: '如商标注册人非入驻企业或实际经营方，请提供商标使用授权书或关联关系证明；以商标注册人为源头的完整授权链路；若商标权利人为自然人，需提供商标权利人亲笔签名的身份证正反两面复印件或亲笔签名+商标权利人手印的授权'
    },
    {
      name: '采购凭证',
      desc: '无法提供《经销或商标使用授权书》的，需提供从品牌方到供应商的完整链路的采购凭证'
    }
  ],
  '5': [
    {
      name: '商标注册证或商标注册申请受理通知书',
      desc: '提供有效期内的商标注册证，露出证件四角，请勿遮挡或模糊，保持信息清晰可见；若办理过变更、转让、续展，请补充上传商标总局颁发的变更、转让、续展证明或受理通知书'
    },
    {
      name: '商标授权文件',
      desc: '如商标注册人非入驻企业或实际经营方，请提供商标使用授权书或关联关系证明；以商标注册人为源头的完整授权链路；若商标权利人为自然人，需提供商标权利人亲笔签名的身份证正反两面复印件或亲笔签名+商标权利人手印的授权'
    },
    {
      name: '采购凭证',
      desc: '无法提供《经销或商标使用授权书》的，需提供从品牌方到供应商的完整链路的采购凭证'
    }
  ]
}


export const columns = [
  {
    title: '资质名称',
    dataIndex: 'name',
    // key: 'name',
  },
  {
    title: '说明',
    dataIndex: 'desc',
    // key: 'desc',
  },
];
